import { __assign } from "tslib";
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faGitAlt } from '@fortawesome/free-brands-svg-icons';
import { faPeopleGroup } from '@fortawesome/pro-solid-svg-icons';
import imgAwsColor from '../../assets/icons/aws-color-18px.png';
import imgGoogleColor from '../../assets/icons/google-color-18px.png';
import imgAzureColor from '../../assets/icons/azure-color-18px.png';
import imgPrivate from '../../assets/icons/private-color-18px.png';
import imgDropbox from '../../assets/icons/type-dropbox.svg';
import imgNginx from '../../assets/icons/type-nginx.svg';
import imgRestApi from '../../assets/icons/type-rest-api.svg';
import imgHttps from '../../assets/icons/HTTPS-app.svg';
import imgSaml from '../../assets/icons/SAML-app.svg';
import imgPolicy from '../../assets/icons/policy.svg';
export var CloudIcon = function (_a) {
    var type = _a.type, background = _a.background, _b = _a.rounded, rounded = _b === void 0 ? false : _b, width = _a.width, height = _a.height, style = _a.style;
    var iconTable = {
        aws: imgAwsColor,
        gcp: imgGoogleColor,
        azure: imgAzureColor,
        private: imgPrivate,
        dropbox: imgDropbox,
        nginx: imgNginx,
        apiRest: imgRestApi,
        https: imgHttps,
        saml: imgSaml,
        github: React.createElement(FontAwesomeIcon, { icon: faGithub, color: 'rgbRGB(46, 57, 85)', size: 'xl' }),
        repository: React.createElement(FontAwesomeIcon, { icon: faGitAlt, color: '#f15033', size: 'xl' }),
        team: React.createElement(FontAwesomeIcon, { icon: faPeopleGroup, color: '#8d94a1', size: 'lg', style: {
                backgroundColor: background ? background : 'initial',
                padding: background ? '6px 4px 6px 4px' : 'initial',
                borderRadius: background ? '4px' : 'initial'
            } }),
        policy: imgPolicy
    };
    var selectedType = type;
    if (typeof iconTable[selectedType] === typeof FontAwesomeIcon) {
        return (iconTable[selectedType]);
    }
    return (React.createElement("img", { src: iconTable[selectedType], alt: iconTable[selectedType], style: __assign({ backgroundColor: background ? background : 'transparent', padding: background ? '6px 6px 6px 6px' : 'none', borderRadius: rounded ? '4px' : '0px', width: width, height: height }, style) }));
};
